import React from "react";

interface CopyIconProps {
    className?: string;
    color?: string;
    size?: "sm" | "md" | "lg" | "xl";
}

export const CopyIcon = ({
    className = "",
    color = "currentColor",
    size = "md",
}: CopyIconProps) => {
    const sizeClasses = {
        sm: "w-4 h-4",       // ~16x16px
        md: "w-4.5 h-4.5",   // ~18x18px
        lg: "w-6 h-6",       // ~24x24px
        xl: "w-8 h-8",       // ~32x32px
    };

    return (
        <div className="icon copy-icon">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                className={`${sizeClasses[size]} rotate-180 ${className}`}
                aria-hidden="true"
            >
                <rect
                    width="14"
                    height="14"
                    x="8"
                    y="8"
                    rx="2"
                    ry="2"
                />
                <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" />
            </svg>
        </div>
    );
};

export default CopyIcon;